<style scoped lang="less">
    .slider-item {
        background-size: cover;
        background-position: center center;
    }

    .slider {
        height: calc(~"100vh - 140px") !important;
    }

    .services {
        padding: 35px;
        h2 {
            text-align: center;
            font-weight: 400;
            font-size: 32px;
        }
    }
</style>
<template>
    <transition name="fade">
        <div>
            <Slider animation="fade" :duration="5000" :speed="2000">
                <SliderItem v-for="(i, index) in slides" :key="index" :style="i"></SliderItem>
            </Slider>
            <!--<section class="services">-->
                <!--<h2>Услуги и цены</h2>-->
            <!--</section>-->
        </div>
    </transition>
</template>

<script>
    import { Slider, SliderItem } from 'vue-easy-slider';
    import axios from 'axios';

    export default {
        name: 'landing',
        components: {
            Slider,
            SliderItem
        },
        data () {
            return {
                slides: [],
                sliderValue: 0,
            };
        },
        methods: {

            getSlides () {
                axios
                    .get('https://api.paparazzi48.ru/main-slider')
                    .then(response => {
                        if (response.data.pics.length) {
                            response.data.pics.forEach(img => {
                                this.slides.push({backgroundImage: 'url(' + img.big + ')'});
                            });
                        }
                    });
            },
        },
        mounted () {
            if (this.slides.length === 0) {
                this.getSlides();
            }
        },
    };
</script>


